import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCommentDots, faMap } from "@fortawesome/free-solid-svg-icons";
import { faCalendarDay, faCalendarWeek } from "@fortawesome/pro-regular-svg-icons";
import {
    faBallotCheck,
    faBuilding,
    faCloudSun,
    faCubes,
    faFlagCheckered,
    faFrame,
    faImage,
    faList,
    faMapMarkerAlt,
    faSunCloud,
    faTemperatureSun,
    faTruckContainer,
} from "@fortawesome/pro-solid-svg-icons";
import Helper from "../../../Helper";
import ComponentHeader from "../../UI/ComponentHeader";

const componentHeaderClassNameLogic = (color: string, active: boolean, singleFlag: boolean) => {
    return Helper.classNames(
        active && !singleFlag && `border-b-2 ${color}`,
        !active && !singleFlag && "grayscale opacity-75",
        "hover:cursor-pointer text-nowrap"
    );
};

const COMPONENT_TAB_INFO: Record<string, { label: string; icon: IconDefinition; color: string }> = {
    projectOverview: { label: "Project Overview", icon: faBuilding, color: "text-plot-blue" },
    logisticsMap: { label: "Logistics Map", icon: faMap, color: "text-plot-blue" },
    deliveriesMap: { label: "Deliveries Map", icon: faTruckContainer, color: "text-plot-orange" },
    deliveriesWeek: { label: "Deliveries Week", icon: faCalendarWeek, color: "text-plot-orange" },
    deliveriesDay: { label: "Deliveries Day", icon: faCalendarDay, color: "text-plot-orange" },
    deliveriesList: { label: "Deliveries List", icon: faList, color: "text-plot-orange" },
    procurementChecklist: { label: "Procurement Checklist", icon: faCubes, color: "text-plot-purple" },
    weather: { label: "Weather", icon: faSunCloud, color: "text-plot-yellow" },
    currentConditions: { label: "Current Conditions", icon: faTemperatureSun, color: "text-plot-yellow" },
    iframe: { label: "iFrame", icon: faFrame, color: "text-plot-blue" },
    customText: { label: "Custom Text", icon: faCommentDots, color: "text-plot-blue" },
    milestones: { label: "Milestones", icon: faFlagCheckered, color: "text-plot-orange" },
    image: { label: "Image", icon: faImage, color: "text-plot-blue" },
};

export const componentLabel = (
    sectionConfig: { view: string; name: string; config: any; filters: any },
    active: boolean = true,
    onClick: () => void,
    singleFlag: boolean
) => {
    const tabInfo = COMPONENT_TAB_INFO[sectionConfig.view];

    if (!tabInfo) {
        return null;
    }

    return (
        <ComponentHeader
            label={sectionConfig.name || tabInfo.label}
            icon={tabInfo.icon}
            color={tabInfo.color}
            className={componentHeaderClassNameLogic(tabInfo.color.replace("text-", "border-"), active, singleFlag)}
            onClick={onClick}
        />
    );
};

export const commandCenterViewOptions = [
    {
        label: "Project Overview",
        value: "projectOverview",
        description: "Project information, required PPE, and additional notices",
        icon: faBuilding,
    },
    {
        label: "Logistics Map",
        value: "logisticsMap",
        description: "Show map of locations and equipment open today",
        icon: faMapMarkerAlt,
    },
    {
        label: "Deliveries Map",
        value: "deliveriesMap",
        description: "Shows map of locations and equipment with deliveries scheduled today",
        icon: faTruckContainer,
    },
    {
        label: "Deliveries Week View",
        value: "deliveriesWeek",
        description: "Weekly calendar view of deliveries",
        icon: faCalendarWeek,
    },
    {
        label: "Deliveries Day View",
        value: "deliveriesDay",
        description: "Daily calendar view of deliveries for today and a chosen number of additional days",
        icon: faCalendarDay,
    },
    {
        label: "Deliveries List View",
        value: "deliveriesList",
        description: "List view of all deliveries for today, tomorrow, and future deliveries",
        icon: faList,
    },
    {
        label: "Procurement Checklist",
        value: "procurementChecklist",
        description: "List of required action items due for procurement",
        icon: faBallotCheck,
    },
    {
        label: "Weather Dashboard",
        value: "weather",
        description: "Live weather conditions, forecasts, and severe weather alerts",
        icon: faCloudSun,
    },
    {
        label: "Current Conditions",
        value: "currentConditions",
        description: "Live current weather conditions only",
        icon: faTemperatureSun,
    },
    {
        label: "Custom Text",
        value: "customText",
        description: "Display a custom message or instructions",
        icon: faCommentDots,
    },
    {
        label: "Milestones",
        value: "milestones",
        description: "Highlight up to 3 upcoming jobsite milestones with a due date",
        icon: faFlagCheckered,
    },
    {
        label: "iFrame",
        value: "iframe",
        description: "Embed external content via an iFrame",
        icon: faFrame,
    },
    {
        label: "Image",
        value: "image",
        description: "Display an image",
        icon: faImage,
    },
];
